// AUTO-GENERATED by independence-sound-admin — do not edit by hand.
// Each cue id maps to its live take URLs; the game plays one at random.
export const CLIPS: Record<string, string[]> = {
  "battle-exchange": [
    new URL('./assets/sounds/battle-exchange.mp3', import.meta.url).href,
    new URL('./assets/sounds/battle-exchange-2.mp3', import.meta.url).href,
    new URL('./assets/sounds/battle-exchange-3.mp3', import.meta.url).href,
    new URL('./assets/sounds/battle-exchange-4.mp3', import.meta.url).href,
  ],
  "battle-blitz": [
    new URL('./assets/sounds/battle-blitz.mp3', import.meta.url).href,
  ],
  "conquest": [
    new URL('./assets/sounds/conquest.mp3', import.meta.url).href,
  ],
  "pull-back": [
    new URL('./assets/sounds/pull-back.mp3', import.meta.url).href,
  ],
  "elimination": [
    new URL('./assets/sounds/elimination.mp3', import.meta.url).href,
  ],
  "reinforce-place": [
    new URL('./assets/sounds/reinforce-place.mp3', import.meta.url).href,
  ],
  "card-draw": [
    new URL('./assets/sounds/card-draw.mp3', import.meta.url).href,
  ],
  "card-trade": [
    new URL('./assets/sounds/card-trade.mp3', import.meta.url).href,
  ],
  "fortify": [
    new URL('./assets/sounds/fortify.mp3', import.meta.url).href,
  ],
  "embark": [
    new URL('./assets/sounds/embark.mp3', import.meta.url).href,
  ],
  "your-turn": [
    new URL('./assets/sounds/your-turn.mp3', import.meta.url).href,
  ],
  "decision-card": [
    new URL('./assets/sounds/decision-card.mp3', import.meta.url).href,
  ],
  "landings": [
    new URL('./assets/sounds/landings.mp3', import.meta.url).href,
  ],
  "select": [
    new URL('./assets/sounds/select.mp3', import.meta.url).href,
  ],
  "ui-click": [
    new URL('./assets/sounds/ui-click.mp3', import.meta.url).href,
  ],
  "game-start": [
    new URL('./assets/sounds/game-start.mp3', import.meta.url).href,
  ],
}
